import { render, staticRenderFns } from "./InputDocument.vue?vue&type=template&id=06957898&scoped=true"
import script from "./InputDocument.vue?vue&type=script&lang=js"
export * from "./InputDocument.vue?vue&type=script&lang=js"
import style0 from "./InputDocument.vue?vue&type=style&index=0&id=06957898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06957898",
  null
  
)

export default component.exports